import { App } from "vue";
import axios from "axios";

export default {
  install(app: App) {
    app.config.globalProperties.$http = axios;
  }
};
